import React from "react";

export default function Tooltip({ copied }) {
  return <p className={`tooltip ${!copied && "hide"}`}>Copied!</p>;
}
